import axios from 'axios'

import { transformResponse } from './axios'

export const fetchVersion = async () => {
  try {
    const result = await transformResponse(axios.get(`/version.json?t=${Date.now()}`))

    return result.version
  } catch (e) {
    return 1
  }
}
